import {
    init as familyProductInit
} from './familyProductComponent';

import template from 'product-shop-the-set.j2';

import { generate } from '../../../core/js/utils/componentUtils';

/**
 * Bootstrap the component onto the page
 */
export function init(store, overrides = {}) {
    const config = {
        template: template,
        templateLocation: '.dom-pdp .dom-product-shop-the-set',
        replace: true,
        children: [
            familyProductInit
        ],
        name: 'productShopTheSetComponent'
    };

    return generate(config, store, overrides);
}
